import classnames from 'classnames';
import { map } from 'ramda';
import React, { FC } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Notification } from '..';
import { useNotificatorRenderer } from '../../../utils/hooks/useNotificator';
import { IOuter } from './NotificationContainer.types';
import styles from './NotificationContainer.scss';

export const NotificationContainer: FC<IOuter> = ({ className, messageProps }) => {
  const { notifications } = useNotificatorRenderer();

  return (
    <TransitionGroup className={classnames(styles.notificationsContainer, className)}>
      {map(
        (notification) => (
          <CSSTransition key={notification.id} classNames={styles} timeout={300}>
            <div className={styles.notification}>
              <Notification notification={notification} messageProps={messageProps} />
            </div>
          </CSSTransition>
        ),
        notifications,
      )}
    </TransitionGroup>
  );
};
